import { Component, HostListener } from "@angular/core";
import { ColDef, ExcelStyle, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { ToastrService } from "ngx-toastr";
import { ApiService } from "../services";
import { LoadingScreenService } from "../shared/loading-screen.service";
import { GridViewBaseComponent } from "../utility/grid-view-base.component";
import { SharedDataService } from "../services/sharedDataService";
import { exportExcel, getExportedExcelFileNameSuffix } from "src/app/utility/common-helper";
import { CapacityBlueprintColumnDefinition } from "./ag-grid-column-definition";
import { Blueprint } from "../generated-models/Blueprint";

@Component({
  standalone: false,
  templateUrl: "./onboard-blueprint.component.html",
  styleUrls: ["../styles.scss", "./capacity-blueprint.scss"],
})
export class CapacityBlueprintOnboardingComponent extends GridViewBaseComponent {
  gridOptions!: GridOptions;
  gridApi!: GridApi;
  initPageSize = 15;
  rowData: Blueprint[] = [];
  headerStyle: ExcelStyle[] = [
    {
      id: "header",
      font: {
        bold: true,
      },
    },
  ];

  keyFilterStats = "filter:capacity-blueprints";
  isAdmin = false;

  constructor(
    protected apiService: ApiService,
    private loadingService: LoadingScreenService,
    protected sharedDataService: SharedDataService,
    private notificationService: ToastrService
  ) {
    super(apiService, sharedDataService);
  }

  async ngOnInit() {
    super.InitAgGrid(CapacityBlueprintColumnDefinition);
    this.apiService
      .getUserProfile()
      .then((profile) => {
        this.isAdmin = !!profile?.IsAdmin;
      })
      .catch(() => {
        this.isAdmin = false;
      });
  }

  onGridReady(params: GridReadyEvent) {
    super.onGridReady(params);
  }

  refreshData() {
    this.loadingService.setLoading(true);
    this.apiService.getCapacityBlueprints().subscribe(
      (response) => {
        this.rowData = response;
        if (this.gridApi) {
          this.gridApi.setGridOption("rowData", this.rowData);
        }
        this.loadingService.setLoading(false);
        super.setupFilterByLocalData();
      },
      (e: any) => {
        this.rowData = [];
        this.loadingService.setLoading(false);
        this.notificationService.error(e);
      }
    );
  }

  refresh() {
    this.loadingService.setLoading(true);
    this.apiService.updateCapacityBlueprints().subscribe(
      () => {
        this.refreshData();
      },
      (e: any) => {
        // complete callback does not fire on error, so clear loading here too.
        this.loadingService.setLoading(false);
        this.notificationService.error(e);
      },
      () => {
        this.loadingService.setLoading(false);
      }
    );
  }

  fullRefresh() {
    this.loadingService.setLoading(true);
    this.apiService.fullRefreshCapacityBlueprints().subscribe(
      () => {
        this.refreshData();
      },
      (e: any) => {
        this.loadingService.setLoading(false);
        this.notificationService.error(e);
      },
      () => {
        this.loadingService.setLoading(false);
      }
    );
  }

  get isAdminUser(): boolean {
    return this.isAdmin;
  }

  @HostListener("window:resize")
  onResize() {
    setTimeout(() => {
      this.gridApi?.autoSizeAllColumns();
    }, 100);
  }

  exportExcel() {
    const fileName = "CapacityBlueprints-" + getExportedExcelFileNameSuffix();
    const sheetName = "Capacity Blueprints";

    this.loadingService.setLoading(true);
    exportExcel(this.gridApi, fileName, sheetName);
    this.loadingService.setLoading(false);
  }
}
